import { render } from "./ToolRenderer.vue?vue&type=template&id=897785ca&scoped=true"
import script from "./ToolRenderer.vue?vue&type=script&lang=js"
export * from "./ToolRenderer.vue?vue&type=script&lang=js"

import "./ToolRenderer.vue?vue&type=style&index=0&id=897785ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897785ca"]])

export default __exports__